import { render, staticRenderFns } from "./IndexPartList.vue?vue&type=template&id=d7fcef54&scoped=true&"
import script from "./IndexPartList.vue?vue&type=script&lang=js&"
export * from "./IndexPartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fcef54",
  null
  
)

export default component.exports